import { useEffect, useState } from "react";
import { DeleteRedIcon, EditIcon, FilterIcon, PlusThickWhiteIcon } from "../../../assets/icons";
import AddCityView from "./AddCityView";
import { useNotification } from "../../toster-notification/NotificationContext";
import { useNavigate } from "react-router-dom";
import Loader from "../../shared/Loader";
import { cityService } from "../../../services/cityService";
import EditCityView from "./EditCityView";
import { CityTableInfoDTO } from "../../../models/city/city.response";
import { confirmDialog } from "../../../utils/confirmDialog";


export default function CitiesSettingsPage() {

    const [isAddCityViewOpen, setIsAddCityViewOpen] = useState(false);
    const [isEditCityViewOpen, setIsEditCityViewOpen] = useState(false);
    const [selectedCityId, setSelectedCityId] = useState<string | null>(null);
    const [cities, setCities] = useState<CityTableInfoDTO[]>([]);
    const [searchTerm, setSearchTerm] = useState("");

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();


    useEffect(() => {
        fetchCities();
    }, []);


    const fetchCities = async () => {
        setLoading(true);
        try {
            const response = await cityService.getTableInfo();
            if (response.success && response.data) {
                setCities(response.data);
            }
        } catch (error) {
            notify("error", "Error Fetching Cities", "An error occurred while fetching cities.");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteCity = async (id: string) => {

        let confirm = await confirmDialog({
            title: "Da li ste sigurni da želite da obrišete ovaj grad?",
            description: "Ova akcija je nepovratna.",
            isDelete: true,
        });

        if (!confirm) {
            return;
        }

        setLoading(true);
        try {
            const response = await cityService.Delete(id);

            if (response.success) {
                notify("success", "City Deleted", "The city has been deleted successfully.");
                fetchCities();
            } else {
                notify("error", "Error Deleting City", response.message || "An error occurred while deleting the city.");
            }
        } catch (error) {
            notify("error", "Error Deleting City", "An error occurred while deleting the city.");
        }
        finally {
            setLoading(false);
        }
    };


    if (loading) {
        return <Loader />;
    }

    return (
        <>

            {isAddCityViewOpen && (
                <AddCityView
                    onClose={() => {
                        setIsAddCityViewOpen(false);
                        fetchCities();
                    }}
                />
            )}

            {isEditCityViewOpen && selectedCityId && (
                <EditCityView
                    id={selectedCityId}
                    onClose={() => {
                        setIsEditCityViewOpen(false);
                        fetchCities();
                    }}
                />
            )}

            <section className="sa-settings-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="sttings-content-wrapper">
                        <div className="header-div">
                            <div>
                                <h2 className="heading-3">Gradovi</h2>
                                <div className="text-block">Pregled svih gradova za lokale</div>
                            </div>
                            <div className="header-button-div">
                                <div className="button-primary" onClick={() => setIsAddCityViewOpen(true)}>
                                    <img loading="lazy" src={PlusThickWhiteIcon} alt="" className="button-image" />
                                    <div className="button-text">Dodaj Grad</div>
                                </div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div table-block-div">
                            <div className="list-header">
                                <div className="list-header-info">
                                    <div className="list-header-title">Gradovi</div>
                                    <div className="list-header-description">
                                        Upravljajte gradovima u sistemu<br />
                                    </div>
                                </div>
                                <div className="list-header-filer">
                                    <img loading="lazy" src={FilterIcon} alt="" className="subcategory-header-filter-image" />
                                    <div className="list-header-filer-form w-form">
                                        <form className="form">
                                            <input className="form-input w-input" placeholder="Pretrazi gradove..."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="list-div">
                                <div className="list-row-div list-header-row cities">
                                    <div>Naziv</div>
                                    <div>Slug</div>
                                    <div>Broj Oblasti</div>
                                    <div>Broj Lokala</div>
                                    <div id="w-node-_915d5c02-6377-b6e1-437a-a4b78a769de5-7969b2d6">Akcije</div>
                                </div>

                                {cities
                                    .filter((city) => {
                                        const lowerCaseSearchTerm = searchTerm.toLowerCase();
                                        return (
                                            city.name.toLowerCase().includes(lowerCaseSearchTerm) ||
                                            city.slug.toLowerCase().includes(lowerCaseSearchTerm)
                                        );
                                    })
                                    .map((city) => (
                                        <div className="list-row-div cities">
                                            <div className="sa-locals-local-user-div">
                                                <div className="bold">{city.name}</div>
                                            </div>
                                            <div className="small-box-div grey-bg">
                                                <div>{city.slug}</div>
                                            </div>
                                            <div className="sa-locals-local-user-div">
                                                <div>{city.locationAreasCount} oblasti</div>
                                            </div>
                                            <div className="sa-locals-local-user-div">
                                                <div>{city.localsCount} lokala</div>
                                            </div>
                                            <div id="w-node-_915d5c02-6377-b6e1-437a-a4b78a769e01-7969b2d6" className="table-row-action-btns-div">
                                                <img loading="lazy" src={EditIcon} alt="" className="category-list-div-row-actions-image"
                                                    onClick={() => {
                                                        setSelectedCityId(city.id);
                                                        setIsEditCityViewOpen(true);
                                                    }}
                                                />
                                                <img loading="lazy" src={DeleteRedIcon} alt="" className="category-list-div-row-actions-image"
                                                    onClick={() => handleDeleteCity(city.id)}
                                                />
                                            </div>
                                        </div>
                                    ))}

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}